import React from 'react';
import { X } from 'lucide-react';
import LayerOverlay from './LayerOverlay';
import './FichaDialog.css';

/* P2b tanda 7c (punto 1) — DIÁLOGO BASE de la ficha de producto. Regla general:
   todo diálogo de la ficha se monta sobre esto, que a su vez vive sobre
   LayerOverlay (el mecanismo raíz del scroll lock: "si oscureces el fondo, lo
   congelas" — el bloqueo se apila solo con diálogos anidados). El esqueleto
   visual es el del selector de imágenes, ya aprobado: cabecera fija, cuerpo con
   scroll INTERNO (max-height 88vh: si el contenido no entra, se desplaza
   adentro, nunca crece fuera del viewport) y pie fijo opcional.
   - `bloqueado` (guardando): ni el fondo ni la X cierran.
   - `subheader`: fila fija bajo el título (p. ej. las pestañas del selector). */
export default function FichaDialog({
  open = true,
  onClose,
  titulo,
  ariaLabel,            // default: el título
  subheader = null,
  footer = null,
  bloqueado = false,
  ancho = 640,          // max-width en px (el alto lo gobierna la base: 88vh)
  className = '',
  children,
}) {
  return (
    <LayerOverlay open={open} className="fd-overlay" onBackdrop={bloqueado ? null : onClose}>
      <div
        className={`fd${className ? ` ${className}` : ''}`}
        role="dialog"
        aria-label={ariaLabel || titulo}
        style={{ maxWidth: ancho }}
      >
        <header className="fd-head">
          <h3>{titulo}</h3>
          <button type="button" className="fd-close" onClick={onClose} aria-label="Cerrar" disabled={bloqueado}>
            <X size={18} />
          </button>
        </header>
        {subheader}
        <div className="fd-body">{children}</div>
        {footer && <footer className="fd-actions">{footer}</footer>}
      </div>
    </LayerOverlay>
  );
}
